import React, { Component } from 'react';
import { observer, inject} from 'mobx-react';
import ConfirmationDialog from '../../portal/dialogs/confirmationDialog';
import CopyPasswordDialog from './copyPasswordDialog';

@inject('translationsStore','resetPasswordByManagerStore')
@observer
export default class ResetPasswordByManagerDialog extends Component{

    state = {
        openResetPasswordDialog: true,
        openDispalyGeneratedPasswordDialog: false
    }; 

    handleResetPasswordDialog = e => {

        this.props.resetPasswordByManagerStore.resetPasswordByManager(this.props.userId)
            .then(() => {
                
                this.setState({
                openResetPasswordDialog : false,
                openDispalyGeneratedPasswordDialog : true
            });
        });
    }

    onClose = () => {
        this.setState({
            openResetPasswordDialog : true,
            openDispalyGeneratedPasswordDialog : false
        });

        this.props.onClose();
    }

    render() {

        const confirmDialogContentFormated =
                    <div>
                        <div>
                            {this.props.translationsStore.translate('RESET_PASSWORD_MODAL_CONTENT_Q')} {this.props.userName}? 
                        </div>
                        <div>
                            {this.props.translationsStore.translate('RESET_PASSWORD_MODAL_CONTENT_UNDONE_ACTION')}
                        </div>
                    </div>;
       
       const copyDialogContent = `${this.props.userName}  ${this.props.translationsStore.translate('TEMP_PASSWORD_MODEL_CONTENT')}`;

        return( 
            <div>
                <ConfirmationDialog 
                    open={this.props.show && this.state.openResetPasswordDialog}
                    onButtonClick={this.handleResetPasswordDialog}
                    onCancelClick={this.onClose}
                    buttonText={this.props.translationsStore.translate('RESET_PASSWORD_MODAL_BUTTON')}
                    titleText={this.props.translationsStore.translate('RESET_PASSWORD_MODAL_TITLE')}
                    contentText={confirmDialogContentFormated}
                    inProgress={this.props.resetPasswordByManagerStore.resetPasswordByManagerProgress}
                />

                <CopyPasswordDialog
                    content={copyDialogContent}
                    open={this.props.show && this.state.openDispalyGeneratedPasswordDialog}
                    onClose={this.onClose}
                />

            </div>);               
    }
}



// WEBPACK FOOTER //
// ./src/components/account/resetPasswordByManager/resetPasswordByManagerDialog.jsx